import { useState } from "react";
import { supabase } from "../utils/supabase";
import { Logo }     from "./UI";

export default function ResetPassword({ onDone }) {
  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [success,  setSuccess]  = useState(false);

  const handleReset = async () => {
    setError("");
    if (password.length < 8)   { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm)   { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess(true);
      setTimeout(() => onDone(), 2500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%", background: "#F9FAFB", border: "1px solid #E5E7EB",
    borderRadius: 8, padding: "10px 12px", color: "#1A1A2E",
    fontSize: 14, outline: "none", boxSizing: "border-box",
  };

  const btnStyle = {
    width: "100%", background: "#E8622A", color: "#fff", border: "none",
    borderRadius: 10, padding: "14px 28px", fontSize: 15,
    fontWeight: 600, cursor: "pointer", opacity: loading ? 0.7 : 1,
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#F7F5F2" }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 48, maxWidth: 420, width: "100%", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
        <div style={{ marginBottom: 32, textAlign: "center" }}>
          <Logo />
        </div>

        {success ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Password updated!</h2>
            <p style={{ color: "#6B7280" }}>Redirecting you to sign in...</p>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, textAlign: "center", color: "#1A1A2E" }}>Set new password</h2>
            <p style={{ color: "#6B7280", marginBottom: 28, textAlign: "center", fontSize: 14 }}>
              Choose a strong password for your PropDesk account.
            </p>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1A2E", display: "block", marginBottom: 6 }}>New Password</label>
              <input
                type="password"
                placeholder="At least 8 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1A2E", display: "block", marginBottom: 6 }}>Confirm Password</label>
              <input
                type="password"
                placeholder="Repeat your password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleReset()}
                style={inputStyle}
              />
            </div>

            {error && (
              <div style={{ background: "#FEF2F2", color: "#DC2626", padding: "10px 14px", borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}

            <button onClick={handleReset} disabled={loading} style={btnStyle}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
